/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import Loader from "./_components/Loader";
import { ToastProvider } from "./_components/toast/ToastProvider";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <div className="min-h-screen w-full overflow-x-clip bg-ground text-primary font-body relative">
          <Loader />
          <App />
        </div>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
